export default "<div class=\"ysh-video-player-component\" *ngIf=\"videoId\">\n  <iframe type=\"text/html\" [src]=\"link\"></iframe>\n</div>\n";